<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/loxf9X/tc-custom/9781630476991.jpg?1702083809537" alt="This image is the cover for the book Crack the Customer Mind Code"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crack the Customer Mind Code
      </h1>
      <p class="bookDescription body article font2">
        <i>Crack the Customer Mind Code</i> upends customary marketing approaches and takes a deeper approach to more successful selling. Based on an analysis of successful marketing campaign patterns, <i>Crack the Customer Mind Code</i> teaches the reader how to align marketing messages that leverage the mind’s natural progression to “yes” through seven steps: 1) identify the persona, 2) stimulate emotion, 3) calm the mind, 4) position or reposition, 5) engage with story, 6) interpret the outcome, and 7) lead prospective customers to give themselves permission to act. With this proven process, organizations can create stronger sales-producing marketing campaigns when the message is aligned with the way in which marketing information is absorbed and processed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Hennerberg
      </h2>
      
      <p class="authorDescription body article">Gary Hennerberg is a mind code marketing strategist, equally accomplished in the dual roles of copywriter/creative director and analytic consultant. He has created and overseen hundreds of marketing campaigns that have reached tens of millions of households and businesses around the world. Hennerberg has reinvented his skills multiple times in his career. As a former marketing and product manager, agency executive, and now an in-demand consultant, creative director, and trainer, he has successfully transferred traditional offline marketing principles to online media. As he deeply thought about the characteristics of his most successful campaigns, he came to realize that aligning messaging with how the mind thinks are essential to remarkable success. Out of this analysis came his book, Crack the Customer Mind Code.With experience in cross-channel marketing, Hennerberg recommends the most effective and cost-efficient blend to generate sales. Hennerberg's experience includes direct mail, catalogs, websites, email, social media, video marketing, programmatic online ad purchasing, and pay-per-click. He blends copywriting and analysis--right brain/left brain thinking--that delivers a whole-brain approach to turnaround underperforming marketing campaigns.As a columnist for Target Marketing Magazine, Hennerberg is in demand as a consultant, speaker, trainer, and author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?501dbf34